import TitleBox from "@/components/title.vue";
import { productTypeList, productList } from "@/utils/const.js";
export default {
  name: "ProductList",
  components: {
    TitleBox
  },
  data() {
    return {
      productTypeList,
      productList,
      titleActiveIndex: []
    };
  },
  computed: {
    showProductList() {
      if (!this.titleActiveIndex.length) {
        return this.productList;
      }
      let arr = [];
      this.titleActiveIndex.forEach(item => {
        const children = this.productTypeList[item].children;
        arr.push(...children);
      });
      arr = [...new Set(arr)];
      return this.productList.filter(item => arr.includes(item.id));
    }
  },
  watch: {
    $route: {
      handler(val) {
        const type = val.query.type;
        if (type === "college") {
          this.titleActiveIndex = [3];
        }
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    titleItemClick(index) {
      const idx = this.titleActiveIndex.findIndex(item => item === index);
      if (idx === -1) {
        this.titleActiveIndex.push(index);
      } else {
        this.titleActiveIndex.splice(idx, 1);
      }
    },
    clearTitleActive() {
      this.titleActiveIndex = [];
    },
    productItemClick(item) {
      this.$router.push("/product/detail?id=" + item.id);
    }
  }
};
